export default {
  resourceType: 'Business',
  loan: {
    rid: 379,
    lastTaxReturnOnOptions: [
      2017,
      2016
    ],
    user: {
      hellosign_api_key: '31053d749f6b8fd49d9b24eebf1379b0',
      __typename: 'User'
    },
    affiliates: [],
    businesses: [
      {
        rid: 479,
        name: 'Test Biz',
        borrowerType: 'oc',
        financial: {
          fiscal_year_end_on: '12/31/2017',
          last_tax_return_on: '12/31/2017',
          __typename: 'Financial'
        },
        fiscalYears: [
          {
            rid: 466,
            year: 2018,
            days: 89,
            period: 'interim',
            __typename: 'FiscalYear'
          },
          {
            rid: 449,
            year: 2017,
            days: 365,
            period: 'tax',
            __typename: 'FiscalYear'
          },
          {
            rid: 448,
            year: 2016,
            days: 365,
            period: 'tax',
            __typename: 'FiscalYear'
          },
          {
            rid: 447,
            year: 2015,
            days: 365,
            period: 'tax',
            __typename: 'FiscalYear'
          },
          {
            rid: 446,
            year: 2014,
            days: 365,
            period: 'tax',
            __typename: 'FiscalYear'
          }
        ],
        taxReturns: [
          {
            formName: '1065',
            year: '2017',
            __typename: 'TaxReturn'
          },
          {
            formName: '1065',
            year: '2017',
            __typename: 'TaxReturn'
          },
          {
            formName: '1065',
            year: '2017',
            __typename: 'TaxReturn'
          },
          {
            formName: '1065',
            year: '2017',
            __typename: 'TaxReturn'
          }
        ],
        taxReturnUrls: [],
        documents: [
          {
            rid: 243,
            category: 'business_bank_search',
            phase: 'main',
            title: 'OFAC',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: '',
            uploaded: false,
            skippable: false,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::Ofac',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 244,
            category: 'business_bank_search',
            phase: 'main',
            title: 'Lien Check',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: '',
            uploaded: false,
            skippable: false,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::LienCheck',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 245,
            category: 'business_bank_search',
            phase: 'main',
            title: 'Insurance - Flood Search',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: '',
            uploaded: false,
            skippable: true,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::InsuranceFloodSearch',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 246,
            category: 'business_insurance',
            phase: 'main',
            title: 'Evidence of General Liability Insurance',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: 'Please give these instructions to your insurance agent. Note: your assigned bank is very particular about the insurance requirements so please let your agent know to pay close attention to the details!',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::InsuranceGeneralLiability',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 247,
            category: 'business_insurance',
            phase: 'main',
            title: 'Evidence of Business Property Insurance',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: 'Please give these instructions to your insurance agent. Note: your assigned bank is very particular about the insurance requirements so please let your agent know to pay close attention to the details!',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::InsurancePersonalProperty',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 248,
            category: 'business_insurance',
            phase: 'main',
            title: "Worker's Compensation Insurance",
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: 'Please give these instructions to your insurance agent. Note: your assigned bank is very particular about the insurance requirements so please let your agent know to pay close attention to the details!',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::InsuranceWorkmansComp',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 249,
            category: 'business_insurance',
            phase: 'main',
            title: 'Flood Insurance',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: 'Complete the form and submit to your insurance agent. Upload the certificate of accord naming our lending partner as a loss payee.',
            uploaded: false,
            skippable: true,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::InsuranceFlood',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 250,
            category: 'business_entity',
            phase: 'main',
            title: 'Asset List',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Provide details about the assets your business owns, as described in the form. Don’t forget to include serial numbers for assets that have a market value greater than $5,000. Use additional pages if needed.',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::BusinessAssets',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 251,
            category: 'business_financial_and_underwriting',
            phase: 'main',
            title: 'Business TaxReturns',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: 'Business TaxReturns',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::TaxReturns',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 254,
            category: 'business_financial_and_underwriting',
            phase: 'main',
            title: '4506T Request',
            status: 'approve_and_commit',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: 'Please scroll down and electronically sign the form. This will complete the tax transcript order so SmartBiz can review your business’s financial qualifications for an SBA loan.',
            uploaded: false,
            skippable: false,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '0439746dfd79bb58d4adb85b19bd54f024425ea8',
            helloSignRoles: [
              {
                rid: '601aed11-67f7-4357-8926-1a05e9862099',
                value: 'signer',
                label: 'Signer',
                __typename: 'SelectorOption'
              }
            ],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: true,
            esignable: false,
            documentKey: '15d062268ae4bce75d6f4af68da867c4a4609a54',
            displayCommentable: true,
            type: 'Document::T4506t',
            skipped: false,
            confirmed: true,
            live: false,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 259,
            category: 'business_bank_search',
            phase: 'main',
            title: 'Business Credit Report',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: '',
            uploaded: false,
            skippable: false,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::BusinessCreditData',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 260,
            category: 'business_funding',
            phase: 'main',
            title: 'Wire Instructions',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: '',
            uploaded: false,
            skippable: false,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::WireInstructions',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 261,
            category: 'business_entity',
            phase: 'main',
            title: 'Certificate of Good Standing',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: "<a target='_blank' href='{:AL=>\"http://sos.alabama.gov/government-records/business-entity-records\", :AK=>\"http://commerce.alaska.gov/CBP/Main/CBPLSearch.aspx?mode=Name\", :AR=>\"http://www.sos.arkansas.gov/corps/search_all.php\", :AZ=>\"http://www.azsos.gov/scripts/TNT_Search_engine.dll\", :CA=>\"https://businesssearch.sos.ca.gov/\", :CO=>\"http://www.sos.state.co.us/biz/BusinessEntityCriteriaExt.do\", :CT=>\"http://www.concord-sots.ct.gov/CONCORD/online?sn=PublicInquiry&eid=9740\", :DE=>\"https://icis.corp.delaware.gov/Ecorp/EntitySearch/NameSearch.aspx\", :FL=>\"http://www.sunbiz.org/search.html\", :GA=>\"https://ecorp.sos.ga.gov/BusinessSearch\", :HI=>\"http://hbe.ehawaii.gov/documents/search.html;jsessionid=284FCBF9ADA4F558FFEA168396A55C74.luka\", :ID=>\"http://www.accessidaho.org/public/sos/corp/search.html?ScriptForm.startstep=crit\", :IL=>\"http://www.ilsos.gov/corporatellc/\", :IN=>\"https://bsd.sos.in.gov/publicbusinesssearch\", :IA=>\"http://sos.iowa.gov/search/business/(S(olaxxhqqhltmeb3vtlgrkorg))/search.aspx\", :KS=>\"https://www.kansas.gov/bess/flow/main;jsessionid=B29E0993734A66E58ABC559E259B17AE.aptcs03-inst0?execution=e1s3\", :KY=>\"https://app.sos.ky.gov/ftsearch/\", :LA=>\"https://coraweb.sos.la.gov/CommercialSearch/CommercialSearch.aspx\", :ME=>\"https://icrs.informe.org/nei-sos-icrs/ICRS\", :MD=>\"http://sdat.dat.maryland.gov/ucc-charter/Pages/CharterSearch/default.aspx\", :MA=>\"http://corp.sec.state.ma.us/corpweb/CorpSearch/CorpSearch.aspx\", :MI=>\"http://www.dleg.state.mi.us/bcs_corp/sr_corp.asp\", :MN=>\"https://mblsportal.sos.state.mn.us/Business/Search\", :MS=>\"https://corp.sos.ms.gov/corp/portal/c/page/corpBusinessIdSearch/portal.aspx?#clear=1\", :MO=>\"https://bsd.sos.mo.gov/BusinessEntity/BESearch.aspx?SearchType=0\", :MT=>\"https://www.mtsosfilings.gov/mtsos-master/service/create.html?service=registerItemSearch\", :NE=>\"https://www.nebraska.gov/sos/corp/corpsearch.cgi?nav=search\", :NV=>\"http://nvsos.gov/sosentitysearch/\", :NH=>\"https://www.sos.nh.gov/corporate/soskb/csearch.asp\", :NJ=>\"https://www.njportal.com/DOR/businessrecords/EntityDocs/BusinessStatCopies.aspx\", :NM=>\"https://portal.sos.state.nm.us/corps/corplookup/Lookdn.aspx\", :NY=>\"http://www.dos.ny.gov/corps/bus_entity_search.html\", :NC=>\"http://www.secretary.state.nc.us/search/index/corp\", :ND=>\"https://apps.nd.gov/sc/busnsrch/busnSearch.htm\", :OH=>\"http://www5.sos.state.oh.us/ords/f?p=100:1:0::NO\", :OK=>\"https://www.sos.ok.gov/business/corp/records.aspx\", :OR=>\"http://egov.sos.state.or.us/br/pkg_web_name_srch_inq.login\", :PA=>\"https://www.corporations.pa.gov/search/corpsearch\", :RI=>\"http://ucc.state.ri.us/CorpSearch/CorpSearchInput.asp\", :SC=>\"http://www.sos.sc.gov/Search%20Business%20Filings\", :SD=>\"https://sos.sd.gov/business/search.aspx\", :TN=>\"http://tnbear.tn.gov/Ecommerce/FilingSearch.aspx\", :TX=>\"https://mycpa.cpa.state.tx.us/coa/\", :UT=>\"https://secure.utah.gov/bes/\", :VT=>\"https://www.vtsosonline.com/online/BusinessInquire\", :VA=>\"https://sccefile.scc.virginia.gov/Find/Business\", :WA=>\"http://www.sos.wa.gov/corps/corps_search.aspx\", :WV=>\"https://apps.wv.gov/SOS/BusinessEntitySearch/\", :WI=>\"https://www.wdfi.org/apps/CorpSearch/Search.aspx?\", :WY=>\"https://wyobiz.wy.gov/business/filingsearch.aspx\", :DC=>\"https://corp.dcra.dc.gov/Account.aspx/LogOn?ReturnUrl=%2fHome.aspx\"}'>Click here to visit your state's website.</a> You will be able to search for this document there. Take a screen shot of the page that shows your business has active status and/or is in good standing with the state. Then upload this to the SmartBiz application.",
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::GoodsCertificate',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 262,
            category: 'business_entity',
            phase: 'main',
            title: 'LLC Articles of Organization',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Provide a copy of the original Articles of Organization with the state’s stamp or seal indicating the Articles were filed with the state. Ensure you include all amendments to the Articles. If you do not have a copy of your Articles of Organization, you can order them on your state’s Secretary of State website.',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::LlcOrganization',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 263,
            category: 'business_entity',
            phase: 'main',
            title: 'Operating Agreement',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: false,
            description: null,
            instructions: "If you do not have an Operating Agreement, you can create a free one in under 5 minutes using a legal services website, such as <a href='http://www.lawdepot.com/contracts/llc-operating-agreement/#.VyQQ4cdAA28' target='_blank'>LawDepot</a>.",
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::OperatingAgreement',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 264,
            category: 'business_funding',
            phase: 'closing',
            title: 'Photo of Voided Business Check',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Upload a photo or color copy of a voided check from your business bank checking account.',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::VoidedBusinessBankAccountCheck',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 265,
            category: 'business_entity',
            phase: 'closing',
            title: "Certificate of Limited Liability Company's Members",
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: "Provide details of your LLC's membership and ownership structure. This certificate must be signed by the Managing Member. If needed, reference your Operating Agreement for details about your company’s members and officers.",
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: 'cdf332d24f3eefd3b6e5bbefbce91ea57aca4050',
            helloSignRoles: [
              {
                rid: '0a17f27b-27be-4359-8d17-a86b1bc7344d',
                value: 'signer',
                label: 'Authorized Signer',
                __typename: 'SelectorOption'
              }
            ],
            helloSignSigners: [
              {
                rid: 'b9db8185-5375-41df-a47f-9c6170b4b9c3',
                role: 'signer',
                email: null,
                name: 'Test Test',
                __typename: 'GuarantorOption'
              }
            ],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: true,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::CertificateLlcMembers',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 266,
            category: 'business_entity',
            phase: 'closing',
            title: 'Member Resolution to Borrow',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Have the resolution signed by all members. It requires a signature from each member and the managing member must sign at the bottom.',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: 'ca8a0aa9f510886a7a51b8aa5ce8db4a6f9f4978',
            helloSignRoles: [
              {
                rid: '6ef2593b-d71c-415f-82cd-5bad1d89fc50',
                value: 'signer_1',
                label: 'Owner 1',
                __typename: 'SelectorOption'
              },
              {
                rid: '6014db22-9d86-402a-b181-c9f4cd0c2a7c',
                value: 'signer_2',
                label: 'Owner 2',
                __typename: 'SelectorOption'
              },
              {
                rid: '169c124d-a5d1-4615-8668-7360586ebcc3',
                value: 'signer_3',
                label: 'Owner 3',
                __typename: 'SelectorOption'
              },
              {
                rid: '471d87cb-fc7b-4f50-ac44-f50c61ce6a4c',
                value: 'signer_4',
                label: 'Owner 4',
                __typename: 'SelectorOption'
              }
            ],
            helloSignSigners: [
              {
                rid: 'a8a026bf-4835-4ab6-abe4-357757695c96',
                role: 'signer_1',
                email: null,
                name: 'John Test',
                __typename: 'GuarantorOption'
              },
              {
                rid: 'd079419d-b162-4789-92a3-94ea0c72fd91',
                role: 'signer_2',
                email: null,
                name: 'Test Test',
                __typename: 'GuarantorOption'
              }
            ],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: true,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::MemberResolutionBorrow',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 269,
            category: 'business_financial_and_underwriting',
            phase: 'main',
            title: '2017 Tax Return',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Include all pages, including the schedules and statements.',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::BusinessTaxReturnLastYear',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 270,
            category: 'business_financial_and_underwriting',
            phase: 'main',
            title: '2016 Tax Return',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Include all pages, including the schedules and statements.',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::BusinessTaxReturnPriorYear',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 271,
            category: 'business_financial_and_underwriting',
            phase: 'main',
            title: '2015 Tax Return',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Include all pages, including the schedules and statements.',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::BusinessTaxReturnTwoYearsPrior',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 273,
            category: 'business_financial_and_underwriting',
            phase: 'main',
            title: 'Balance Sheet',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: '',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::BalanceSheet',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 287,
            category: 'business_financial_and_underwriting',
            phase: 'main',
            title: '2017 Profit & Loss Statement',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: '',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::IncomeStatement',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 288,
            category: 'business_financial_and_underwriting',
            phase: 'main',
            title: '2018 Profit & Loss Statement',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: '',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::LastIncomeStatement',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          }
        ],
        archivedDocuments: [],
        guarantors: [
          {
            rid: 578,
            name: 'Test Test',
            email: null,
            taxReturns: [],
            taxReturnUrls: [],
            business: {
              rid: 479,
              __typename: 'Business'
            },
            documents: [
              {
                rid: 252,
                category: 'Test Test',
                phase: 'closing',
                title: "Photo of Driver's License",
                status: 'pending_review',
                comment: null,
                filenames: [],
                adminOnly: null,
                description: null,
                instructions: 'Provide a photo or color copy of the front and back of your identification. Taking a photo with your smartphone works well.',
                uploaded: false,
                skippable: false,
                editable: true,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::DriverLicensePhoto',
                skipped: false,
                confirmed: false,
                live: true,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 253,
                category: 'Test Test',
                phase: 'main',
                title: 'Guarantor TaxReturns',
                status: 'pending_review',
                comment: null,
                filenames: [],
                adminOnly: true,
                description: null,
                instructions: 'Guarantor TaxReturns',
                uploaded: false,
                skippable: true,
                editable: true,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::TaxReturns',
                skipped: false,
                confirmed: false,
                live: true,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 255,
                category: 'Test Test',
                phase: 'main',
                title: '4506T Request',
                status: 'approve_and_commit',
                comment: null,
                filenames: [],
                adminOnly: true,
                description: null,
                instructions: 'Please scroll down and electronically sign the form. This will complete the tax transcript order so SmartBiz can review your business’s financial qualifications for an SBA loan.',
                uploaded: false,
                skippable: false,
                editable: false,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '0439746dfd79bb58d4adb85b19bd54f024425ea8',
                helloSignRoles: [
                  {
                    rid: '5c13e367-72b0-4b03-aa07-f08a79aa1c06',
                    value: 'signer',
                    label: 'Signer',
                    __typename: 'SelectorOption'
                  }
                ],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: true,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::T4506t',
                skipped: false,
                confirmed: true,
                live: false,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 258,
                category: 'Test Test',
                phase: 'main',
                title: 'Experian Credit Data Soft Pull',
                status: 'approve_and_commit',
                comment: null,
                filenames: [
                  'cbd_info20180914-4850-aku8a4.xml'
                ],
                adminOnly: true,
                description: null,
                instructions: '',
                uploaded: true,
                skippable: false,
                editable: false,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::ExperianCreditDataSoft',
                skipped: false,
                confirmed: true,
                live: false,
                creditDoc: true,
                bankEditable: false,
                fileUrls: [
                  {
                    filename: 'cbd_info20180914-4850-aku8a4.xml',
                    link: '/admin/loans/379/credit_report?document=258',
                    rid: 'a1fbfe1f-e614-4f8f-86b0-73ad3bfec6fe',
                    __typename: 'FileLink'
                  }
                ],
                files: [
                  {
                    rid: '2cd45a0d-796b-4666-99fd-5c024dcab276',
                    isNew: false,
                    name: 'cbd_info20180914-4850-aku8a4.xml',
                    __typename: 'File'
                  }
                ],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 274,
                category: 'Test Test',
                phase: 'main',
                title: '2017 Personal Tax Return',
                status: 'pending_review',
                comment: null,
                filenames: [],
                adminOnly: null,
                description: null,
                instructions: 'Include all pages, including the schedules and statements.',
                uploaded: false,
                skippable: true,
                editable: true,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::PersonalTaxReturnLastYear',
                skipped: false,
                confirmed: false,
                live: true,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 275,
                category: 'Test Test',
                phase: 'main',
                title: '2016 Personal Tax Return',
                status: 'pending_review',
                comment: null,
                filenames: [],
                adminOnly: null,
                description: null,
                instructions: 'Include all pages, including the schedules and statements.',
                uploaded: false,
                skippable: true,
                editable: true,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::PersonalTaxReturnPriorYear',
                skipped: false,
                confirmed: false,
                live: true,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 276,
                category: 'Test Test',
                phase: 'main',
                title: '2015 Personal Tax Return',
                status: 'pending_review',
                comment: null,
                filenames: [],
                adminOnly: null,
                description: null,
                instructions: 'Include all pages, including the schedules and statements.',
                uploaded: false,
                skippable: true,
                editable: true,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::PersonalTaxReturnTwoYearsPrior',
                skipped: false,
                confirmed: false,
                live: true,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              }
            ],
            archivedDocuments: [],
            __typename: 'Guarantor'
          },
          {
            rid: 579,
            name: 'John Test',
            email: null,
            taxReturns: [],
            taxReturnUrls: [],
            business: {
              rid: 479,
              __typename: 'Business'
            },
            documents: [
              {
                rid: 256,
                category: 'John Test',
                phase: 'main',
                title: '4506T Request',
                status: 'approve_and_commit',
                comment: null,
                filenames: [],
                adminOnly: true,
                description: null,
                instructions: 'Please scroll down and electronically sign the form. This will complete the tax transcript order so SmartBiz can review your business’s financial qualifications for an SBA loan.',
                uploaded: false,
                skippable: false,
                editable: false,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '0439746dfd79bb58d4adb85b19bd54f024425ea8',
                helloSignRoles: [
                  {
                    rid: 'f9b27b3b-1d8c-4106-acf4-e8523ab79445',
                    value: 'signer',
                    label: 'Signer',
                    __typename: 'SelectorOption'
                  }
                ],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: true,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::T4506t',
                skipped: false,
                confirmed: true,
                live: false,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 257,
                category: 'John Test',
                phase: 'main',
                title: 'Experian Credit Data Soft Pull',
                status: 'approve_and_commit',
                comment: null,
                filenames: [
                  'cbd_info20180914-4850-1ppdvmc.xml'
                ],
                adminOnly: true,
                description: null,
                instructions: '',
                uploaded: true,
                skippable: false,
                editable: false,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::ExperianCreditDataSoft',
                skipped: false,
                confirmed: true,
                live: false,
                creditDoc: true,
                bankEditable: false,
                fileUrls: [
                  {
                    filename: 'cbd_info20180914-4850-1ppdvmc.xml',
                    link: '/admin/loans/379/credit_report?document=257',
                    rid: 'b7b0c7b7-6e5c-47ee-8994-c3e7788e8b15',
                    __typename: 'FileLink'
                  }
                ],
                files: [
                  {
                    rid: '1e47b402-64f0-402c-87db-2e1919af00c6',
                    isNew: false,
                    name: 'cbd_info20180914-4850-1ppdvmc.xml',
                    __typename: 'File'
                  }
                ],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 267,
                category: 'John Test',
                phase: 'closing',
                title: "Photo of Driver's License",
                status: 'pending_review',
                comment: null,
                filenames: [],
                adminOnly: null,
                description: null,
                instructions: 'Provide a photo or color copy of the front and back of your identification. Taking a photo with your smartphone works well.',
                uploaded: false,
                skippable: false,
                editable: true,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::DriverLicensePhoto',
                skipped: false,
                confirmed: false,
                live: true,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 268,
                category: 'John Test',
                phase: 'main',
                title: 'Guarantor TaxReturns',
                status: 'pending_review',
                comment: null,
                filenames: [],
                adminOnly: true,
                description: null,
                instructions: 'Guarantor TaxReturns',
                uploaded: false,
                skippable: true,
                editable: true,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::TaxReturns',
                skipped: false,
                confirmed: false,
                live: true,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 277,
                category: 'John Test',
                phase: 'main',
                title: '2017 Personal Tax Return',
                status: 'pending_review',
                comment: null,
                filenames: [],
                adminOnly: null,
                description: null,
                instructions: 'Include all pages, including the schedules and statements.',
                uploaded: false,
                skippable: true,
                editable: true,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::PersonalTaxReturnLastYear',
                skipped: false,
                confirmed: false,
                live: true,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 278,
                category: 'John Test',
                phase: 'main',
                title: '2016 Personal Tax Return',
                status: 'pending_review',
                comment: null,
                filenames: [],
                adminOnly: null,
                description: null,
                instructions: 'Include all pages, including the schedules and statements.',
                uploaded: false,
                skippable: true,
                editable: true,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::PersonalTaxReturnPriorYear',
                skipped: false,
                confirmed: false,
                live: true,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              },
              {
                rid: 279,
                category: 'John Test',
                phase: 'main',
                title: '2015 Personal Tax Return',
                status: 'pending_review',
                comment: null,
                filenames: [],
                adminOnly: null,
                description: null,
                instructions: 'Include all pages, including the schedules and statements.',
                uploaded: false,
                skippable: true,
                editable: true,
                header_image_url: null,
                esignReminderSentAt: null,
                helloSignTemplateId: '',
                helloSignRoles: [],
                helloSignSigners: [],
                hasUploadNotifications: false,
                custom: false,
                deletable: false,
                esignable: false,
                documentKey: null,
                displayCommentable: true,
                type: 'Document::PersonalTaxReturnTwoYearsPrior',
                skipped: false,
                confirmed: false,
                live: true,
                creditDoc: false,
                bankEditable: false,
                fileUrls: [],
                files: [],
                signatureRequests: [],
                __typename: 'Document'
              }
            ],
            archivedDocuments: [],
            __typename: 'Guarantor'
          }
        ],
        corporateGuarantors: [],
        senior_staff: [],
        __typename: 'Business'
      }
    ],
    creditMemoAuthWarnings: [],
    __typename: 'Loan'
  },
  entity: {
    rid: 479,
    name: 'Test Biz',
    borrowerType: 'oc',
    financial: {
      fiscal_year_end_on: '12/31/2017',
      last_tax_return_on: '12/31/2017',
      __typename: 'Financial'
    },
    fiscalYears: [
      {
        rid: 466,
        year: 2018,
        days: 89,
        period: 'interim',
        __typename: 'FiscalYear'
      },
      {
        rid: 449,
        year: 2017,
        days: 365,
        period: 'tax',
        __typename: 'FiscalYear'
      },
      {
        rid: 448,
        year: 2016,
        days: 365,
        period: 'tax',
        __typename: 'FiscalYear'
      },
      {
        rid: 447,
        year: 2015,
        days: 365,
        period: 'tax',
        __typename: 'FiscalYear'
      },
      {
        rid: 446,
        year: 2014,
        days: 365,
        period: 'tax',
        __typename: 'FiscalYear'
      }
    ],
    taxReturns: [
      {
        formName: '1065',
        year: '2017',
        __typename: 'TaxReturn'
      },
      {
        formName: '1065',
        year: '2017',
        __typename: 'TaxReturn'
      },
      {
        formName: '1065',
        year: '2017',
        __typename: 'TaxReturn'
      },
      {
        formName: '1065',
        year: '2017',
        __typename: 'TaxReturn'
      }
    ],
    taxReturnUrls: [],
    documents: [
      {
        rid: 243,
        category: 'business_bank_search',
        phase: 'main',
        title: 'OFAC',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: '',
        uploaded: false,
        skippable: false,
        editable: false,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::Ofac',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 244,
        category: 'business_bank_search',
        phase: 'main',
        title: 'Lien Check',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: '',
        uploaded: false,
        skippable: false,
        editable: false,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::LienCheck',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 245,
        category: 'business_bank_search',
        phase: 'main',
        title: 'Insurance - Flood Search',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: '',
        uploaded: false,
        skippable: true,
        editable: false,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::InsuranceFloodSearch',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 246,
        category: 'business_insurance',
        phase: 'main',
        title: 'Evidence of General Liability Insurance',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: 'Please give these instructions to your insurance agent. Note: your assigned bank is very particular about the insurance requirements so please let your agent know to pay close attention to the details!',
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::InsuranceGeneralLiability',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 247,
        category: 'business_insurance',
        phase: 'main',
        title: 'Evidence of Business Property Insurance',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: 'Please give these instructions to your insurance agent. Note: your assigned bank is very particular about the insurance requirements so please let your agent know to pay close attention to the details!',
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::InsurancePersonalProperty',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 248,
        category: 'business_insurance',
        phase: 'main',
        title: "Worker's Compensation Insurance",
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: 'Please give these instructions to your insurance agent. Note: your assigned bank is very particular about the insurance requirements so please let your agent know to pay close attention to the details!',
        uploaded: false,
        skippable: true,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::InsuranceWorkmansComp',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 249,
        category: 'business_insurance',
        phase: 'main',
        title: 'Flood Insurance',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: 'Complete the form and submit to your insurance agent. Upload the certificate of accord naming our lending partner as a loss payee.',
        uploaded: false,
        skippable: true,
        editable: false,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::InsuranceFlood',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 250,
        category: 'business_entity',
        phase: 'main',
        title: 'Asset List',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: 'Provide details about the assets your business owns, as described in the form. Don’t forget to include serial numbers for assets that have a market value greater than $5,000. Use additional pages if needed.',
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::BusinessAssets',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 251,
        category: 'business_financial_and_underwriting',
        phase: 'main',
        title: 'Business TaxReturns',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: 'Business TaxReturns',
        uploaded: false,
        skippable: true,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::TaxReturns',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 254,
        category: 'business_financial_and_underwriting',
        phase: 'main',
        title: '4506T Request',
        status: 'approve_and_commit',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: 'Please scroll down and electronically sign the form. This will complete the tax transcript order so SmartBiz can review your business’s financial qualifications for an SBA loan.',
        uploaded: false,
        skippable: false,
        editable: false,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '0439746dfd79bb58d4adb85b19bd54f024425ea8',
        helloSignRoles: [
          {
            rid: '601aed11-67f7-4357-8926-1a05e9862099',
            value: 'signer',
            label: 'Signer',
            __typename: 'SelectorOption'
          }
        ],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: true,
        esignable: false,
        documentKey: '15d062268ae4bce75d6f4af68da867c4a4609a54',
        displayCommentable: true,
        type: 'Document::T4506t',
        skipped: false,
        confirmed: true,
        live: false,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 259,
        category: 'business_bank_search',
        phase: 'main',
        title: 'Business Credit Report',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: '',
        uploaded: false,
        skippable: false,
        editable: false,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::BusinessCreditData',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 260,
        category: 'business_funding',
        phase: 'main',
        title: 'Wire Instructions',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: true,
        description: null,
        instructions: '',
        uploaded: false,
        skippable: false,
        editable: false,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::WireInstructions',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 261,
        category: 'business_entity',
        phase: 'main',
        title: 'Certificate of Good Standing',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: "<a target='_blank' href='{:AL=>\"http://sos.alabama.gov/government-records/business-entity-records\", :AK=>\"http://commerce.alaska.gov/CBP/Main/CBPLSearch.aspx?mode=Name\", :AR=>\"http://www.sos.arkansas.gov/corps/search_all.php\", :AZ=>\"http://www.azsos.gov/scripts/TNT_Search_engine.dll\", :CA=>\"https://businesssearch.sos.ca.gov/\", :CO=>\"http://www.sos.state.co.us/biz/BusinessEntityCriteriaExt.do\", :CT=>\"http://www.concord-sots.ct.gov/CONCORD/online?sn=PublicInquiry&eid=9740\", :DE=>\"https://icis.corp.delaware.gov/Ecorp/EntitySearch/NameSearch.aspx\", :FL=>\"http://www.sunbiz.org/search.html\", :GA=>\"https://ecorp.sos.ga.gov/BusinessSearch\", :HI=>\"http://hbe.ehawaii.gov/documents/search.html;jsessionid=284FCBF9ADA4F558FFEA168396A55C74.luka\", :ID=>\"http://www.accessidaho.org/public/sos/corp/search.html?ScriptForm.startstep=crit\", :IL=>\"http://www.ilsos.gov/corporatellc/\", :IN=>\"https://bsd.sos.in.gov/publicbusinesssearch\", :IA=>\"http://sos.iowa.gov/search/business/(S(olaxxhqqhltmeb3vtlgrkorg))/search.aspx\", :KS=>\"https://www.kansas.gov/bess/flow/main;jsessionid=B29E0993734A66E58ABC559E259B17AE.aptcs03-inst0?execution=e1s3\", :KY=>\"https://app.sos.ky.gov/ftsearch/\", :LA=>\"https://coraweb.sos.la.gov/CommercialSearch/CommercialSearch.aspx\", :ME=>\"https://icrs.informe.org/nei-sos-icrs/ICRS\", :MD=>\"http://sdat.dat.maryland.gov/ucc-charter/Pages/CharterSearch/default.aspx\", :MA=>\"http://corp.sec.state.ma.us/corpweb/CorpSearch/CorpSearch.aspx\", :MI=>\"http://www.dleg.state.mi.us/bcs_corp/sr_corp.asp\", :MN=>\"https://mblsportal.sos.state.mn.us/Business/Search\", :MS=>\"https://corp.sos.ms.gov/corp/portal/c/page/corpBusinessIdSearch/portal.aspx?#clear=1\", :MO=>\"https://bsd.sos.mo.gov/BusinessEntity/BESearch.aspx?SearchType=0\", :MT=>\"https://www.mtsosfilings.gov/mtsos-master/service/create.html?service=registerItemSearch\", :NE=>\"https://www.nebraska.gov/sos/corp/corpsearch.cgi?nav=search\", :NV=>\"http://nvsos.gov/sosentitysearch/\", :NH=>\"https://www.sos.nh.gov/corporate/soskb/csearch.asp\", :NJ=>\"https://www.njportal.com/DOR/businessrecords/EntityDocs/BusinessStatCopies.aspx\", :NM=>\"https://portal.sos.state.nm.us/corps/corplookup/Lookdn.aspx\", :NY=>\"http://www.dos.ny.gov/corps/bus_entity_search.html\", :NC=>\"http://www.secretary.state.nc.us/search/index/corp\", :ND=>\"https://apps.nd.gov/sc/busnsrch/busnSearch.htm\", :OH=>\"http://www5.sos.state.oh.us/ords/f?p=100:1:0::NO\", :OK=>\"https://www.sos.ok.gov/business/corp/records.aspx\", :OR=>\"http://egov.sos.state.or.us/br/pkg_web_name_srch_inq.login\", :PA=>\"https://www.corporations.pa.gov/search/corpsearch\", :RI=>\"http://ucc.state.ri.us/CorpSearch/CorpSearchInput.asp\", :SC=>\"http://www.sos.sc.gov/Search%20Business%20Filings\", :SD=>\"https://sos.sd.gov/business/search.aspx\", :TN=>\"http://tnbear.tn.gov/Ecommerce/FilingSearch.aspx\", :TX=>\"https://mycpa.cpa.state.tx.us/coa/\", :UT=>\"https://secure.utah.gov/bes/\", :VT=>\"https://www.vtsosonline.com/online/BusinessInquire\", :VA=>\"https://sccefile.scc.virginia.gov/Find/Business\", :WA=>\"http://www.sos.wa.gov/corps/corps_search.aspx\", :WV=>\"https://apps.wv.gov/SOS/BusinessEntitySearch/\", :WI=>\"https://www.wdfi.org/apps/CorpSearch/Search.aspx?\", :WY=>\"https://wyobiz.wy.gov/business/filingsearch.aspx\", :DC=>\"https://corp.dcra.dc.gov/Account.aspx/LogOn?ReturnUrl=%2fHome.aspx\"}'>Click here to visit your state's website.</a> You will be able to search for this document there. Take a screen shot of the page that shows your business has active status and/or is in good standing with the state. Then upload this to the SmartBiz application.",
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::GoodsCertificate',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 262,
        category: 'business_entity',
        phase: 'main',
        title: 'LLC Articles of Organization',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: 'Provide a copy of the original Articles of Organization with the state’s stamp or seal indicating the Articles were filed with the state. Ensure you include all amendments to the Articles. If you do not have a copy of your Articles of Organization, you can order them on your state’s Secretary of State website.',
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::LlcOrganization',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 263,
        category: 'business_entity',
        phase: 'main',
        title: 'Operating Agreement',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: false,
        description: null,
        instructions: "If you do not have an Operating Agreement, you can create a free one in under 5 minutes using a legal services website, such as <a href='http://www.lawdepot.com/contracts/llc-operating-agreement/#.VyQQ4cdAA28' target='_blank'>LawDepot</a>.",
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::OperatingAgreement',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 264,
        category: 'business_funding',
        phase: 'closing',
        title: 'Photo of Voided Business Check',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: 'Upload a photo or color copy of a voided check from your business bank checking account.',
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::VoidedBusinessBankAccountCheck',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 265,
        category: 'business_entity',
        phase: 'closing',
        title: "Certificate of Limited Liability Company's Members",
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: "Provide details of your LLC's membership and ownership structure. This certificate must be signed by the Managing Member. If needed, reference your Operating Agreement for details about your company’s members and officers.",
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: 'cdf332d24f3eefd3b6e5bbefbce91ea57aca4050',
        helloSignRoles: [
          {
            rid: '0a17f27b-27be-4359-8d17-a86b1bc7344d',
            value: 'signer',
            label: 'Authorized Signer',
            __typename: 'SelectorOption'
          }
        ],
        helloSignSigners: [
          {
            rid: 'b9db8185-5375-41df-a47f-9c6170b4b9c3',
            role: 'signer',
            email: null,
            name: 'Test Test',
            __typename: 'GuarantorOption'
          }
        ],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: true,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::CertificateLlcMembers',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 266,
        category: 'business_entity',
        phase: 'closing',
        title: 'Member Resolution to Borrow',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: 'Have the resolution signed by all members. It requires a signature from each member and the managing member must sign at the bottom.',
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: 'ca8a0aa9f510886a7a51b8aa5ce8db4a6f9f4978',
        helloSignRoles: [
          {
            rid: '6ef2593b-d71c-415f-82cd-5bad1d89fc50',
            value: 'signer_1',
            label: 'Owner 1',
            __typename: 'SelectorOption'
          },
          {
            rid: '6014db22-9d86-402a-b181-c9f4cd0c2a7c',
            value: 'signer_2',
            label: 'Owner 2',
            __typename: 'SelectorOption'
          },
          {
            rid: '169c124d-a5d1-4615-8668-7360586ebcc3',
            value: 'signer_3',
            label: 'Owner 3',
            __typename: 'SelectorOption'
          },
          {
            rid: '471d87cb-fc7b-4f50-ac44-f50c61ce6a4c',
            value: 'signer_4',
            label: 'Owner 4',
            __typename: 'SelectorOption'
          }
        ],
        helloSignSigners: [
          {
            rid: 'a8a026bf-4835-4ab6-abe4-357757695c96',
            role: 'signer_1',
            email: null,
            name: 'John Test',
            __typename: 'GuarantorOption'
          },
          {
            rid: 'd079419d-b162-4789-92a3-94ea0c72fd91',
            role: 'signer_2',
            email: null,
            name: 'Test Test',
            __typename: 'GuarantorOption'
          }
        ],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: true,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::MemberResolutionBorrow',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 269,
        category: 'business_financial_and_underwriting',
        phase: 'main',
        title: '2017 Tax Return',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: 'Include all pages, including the schedules and statements.',
        uploaded: false,
        skippable: true,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::BusinessTaxReturnLastYear',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 270,
        category: 'business_financial_and_underwriting',
        phase: 'main',
        title: '2016 Tax Return',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: 'Include all pages, including the schedules and statements.',
        uploaded: false,
        skippable: true,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::BusinessTaxReturnPriorYear',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 271,
        category: 'business_financial_and_underwriting',
        phase: 'main',
        title: '2015 Tax Return',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: 'Include all pages, including the schedules and statements.',
        uploaded: false,
        skippable: true,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::BusinessTaxReturnTwoYearsPrior',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 273,
        category: 'business_financial_and_underwriting',
        phase: 'main',
        title: 'Balance Sheet',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: '',
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::BalanceSheet',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 287,
        category: 'business_financial_and_underwriting',
        phase: 'main',
        title: '2017 Profit & Loss Statement',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: '',
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::IncomeStatement',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      },
      {
        rid: 288,
        category: 'business_financial_and_underwriting',
        phase: 'main',
        title: '2018 Profit & Loss Statement',
        status: 'pending_review',
        comment: null,
        filenames: [],
        adminOnly: null,
        description: null,
        instructions: '',
        uploaded: false,
        skippable: false,
        editable: true,
        header_image_url: null,
        esignReminderSentAt: null,
        helloSignTemplateId: '',
        helloSignRoles: [],
        helloSignSigners: [],
        hasUploadNotifications: false,
        custom: false,
        deletable: false,
        esignable: false,
        documentKey: null,
        displayCommentable: true,
        type: 'Document::LastIncomeStatement',
        skipped: false,
        confirmed: false,
        live: true,
        creditDoc: false,
        bankEditable: false,
        fileUrls: [],
        files: [],
        signatureRequests: [],
        __typename: 'Document'
      }
    ],
    archivedDocuments: [],
    guarantors: [
      {
        rid: 578,
        name: 'Test Test',
        email: null,
        taxReturns: [],
        taxReturnUrls: [],
        business: {
          rid: 479,
          __typename: 'Business'
        },
        documents: [
          {
            rid: 252,
            category: 'Test Test',
            phase: 'closing',
            title: "Photo of Driver's License",
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Provide a photo or color copy of the front and back of your identification. Taking a photo with your smartphone works well.',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::DriverLicensePhoto',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 253,
            category: 'Test Test',
            phase: 'main',
            title: 'Guarantor TaxReturns',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: 'Guarantor TaxReturns',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::TaxReturns',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 255,
            category: 'Test Test',
            phase: 'main',
            title: '4506T Request',
            status: 'approve_and_commit',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: 'Please scroll down and electronically sign the form. This will complete the tax transcript order so SmartBiz can review your business’s financial qualifications for an SBA loan.',
            uploaded: false,
            skippable: false,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '0439746dfd79bb58d4adb85b19bd54f024425ea8',
            helloSignRoles: [
              {
                rid: '5c13e367-72b0-4b03-aa07-f08a79aa1c06',
                value: 'signer',
                label: 'Signer',
                __typename: 'SelectorOption'
              }
            ],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: true,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::T4506t',
            skipped: false,
            confirmed: true,
            live: false,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 258,
            category: 'Test Test',
            phase: 'main',
            title: 'Experian Credit Data Soft Pull',
            status: 'approve_and_commit',
            comment: null,
            filenames: [
              'cbd_info20180914-4850-aku8a4.xml'
            ],
            adminOnly: true,
            description: null,
            instructions: '',
            uploaded: true,
            skippable: false,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::ExperianCreditDataSoft',
            skipped: false,
            confirmed: true,
            live: false,
            creditDoc: true,
            bankEditable: false,
            fileUrls: [
              {
                filename: 'cbd_info20180914-4850-aku8a4.xml',
                link: '/admin/loans/379/credit_report?document=258',
                rid: 'a1fbfe1f-e614-4f8f-86b0-73ad3bfec6fe',
                __typename: 'FileLink'
              }
            ],
            files: [
              {
                rid: '2cd45a0d-796b-4666-99fd-5c024dcab276',
                isNew: false,
                name: 'cbd_info20180914-4850-aku8a4.xml',
                __typename: 'File'
              }
            ],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 274,
            category: 'Test Test',
            phase: 'main',
            title: '2017 Personal Tax Return',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Include all pages, including the schedules and statements.',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::PersonalTaxReturnLastYear',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 275,
            category: 'Test Test',
            phase: 'main',
            title: '2016 Personal Tax Return',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Include all pages, including the schedules and statements.',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::PersonalTaxReturnPriorYear',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 276,
            category: 'Test Test',
            phase: 'main',
            title: '2015 Personal Tax Return',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Include all pages, including the schedules and statements.',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::PersonalTaxReturnTwoYearsPrior',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          }
        ],
        archivedDocuments: [],
        __typename: 'Guarantor'
      },
      {
        rid: 579,
        name: 'John Test',
        email: null,
        taxReturns: [],
        taxReturnUrls: [],
        business: {
          rid: 479,
          __typename: 'Business'
        },
        documents: [
          {
            rid: 256,
            category: 'John Test',
            phase: 'main',
            title: '4506T Request',
            status: 'approve_and_commit',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: 'Please scroll down and electronically sign the form. This will complete the tax transcript order so SmartBiz can review your business’s financial qualifications for an SBA loan.',
            uploaded: false,
            skippable: false,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '0439746dfd79bb58d4adb85b19bd54f024425ea8',
            helloSignRoles: [
              {
                rid: 'f9b27b3b-1d8c-4106-acf4-e8523ab79445',
                value: 'signer',
                label: 'Signer',
                __typename: 'SelectorOption'
              }
            ],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: true,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::T4506t',
            skipped: false,
            confirmed: true,
            live: false,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 257,
            category: 'John Test',
            phase: 'main',
            title: 'Experian Credit Data Soft Pull',
            status: 'approve_and_commit',
            comment: null,
            filenames: [
              'cbd_info20180914-4850-1ppdvmc.xml'
            ],
            adminOnly: true,
            description: null,
            instructions: '',
            uploaded: true,
            skippable: false,
            editable: false,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::ExperianCreditDataSoft',
            skipped: false,
            confirmed: true,
            live: false,
            creditDoc: true,
            bankEditable: false,
            fileUrls: [
              {
                filename: 'cbd_info20180914-4850-1ppdvmc.xml',
                link: '/admin/loans/379/credit_report?document=257',
                rid: 'b7b0c7b7-6e5c-47ee-8994-c3e7788e8b15',
                __typename: 'FileLink'
              }
            ],
            files: [
              {
                rid: '1e47b402-64f0-402c-87db-2e1919af00c6',
                isNew: false,
                name: 'cbd_info20180914-4850-1ppdvmc.xml',
                __typename: 'File'
              }
            ],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 267,
            category: 'John Test',
            phase: 'closing',
            title: "Photo of Driver's License",
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Provide a photo or color copy of the front and back of your identification. Taking a photo with your smartphone works well.',
            uploaded: false,
            skippable: false,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::DriverLicensePhoto',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 268,
            category: 'John Test',
            phase: 'main',
            title: 'Guarantor TaxReturns',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: true,
            description: null,
            instructions: 'Guarantor TaxReturns',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::TaxReturns',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 277,
            category: 'John Test',
            phase: 'main',
            title: '2017 Personal Tax Return',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Include all pages, including the schedules and statements.',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::PersonalTaxReturnLastYear',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 278,
            category: 'John Test',
            phase: 'main',
            title: '2016 Personal Tax Return',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Include all pages, including the schedules and statements.',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::PersonalTaxReturnPriorYear',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          },
          {
            rid: 279,
            category: 'John Test',
            phase: 'main',
            title: '2015 Personal Tax Return',
            status: 'pending_review',
            comment: null,
            filenames: [],
            adminOnly: null,
            description: null,
            instructions: 'Include all pages, including the schedules and statements.',
            uploaded: false,
            skippable: true,
            editable: true,
            header_image_url: null,
            esignReminderSentAt: null,
            helloSignTemplateId: '',
            helloSignRoles: [],
            helloSignSigners: [],
            hasUploadNotifications: false,
            custom: false,
            deletable: false,
            esignable: false,
            documentKey: null,
            displayCommentable: true,
            type: 'Document::PersonalTaxReturnTwoYearsPrior',
            skipped: false,
            confirmed: false,
            live: true,
            creditDoc: false,
            bankEditable: false,
            fileUrls: [],
            files: [],
            signatureRequests: [],
            __typename: 'Document'
          }
        ],
        archivedDocuments: [],
        __typename: 'Guarantor'
      }
    ],
    corporateGuarantors: [],
    senior_staff: [],
    __typename: 'Business'
  }
}
